import React, { useState } from 'react';
import { Stethoscope, Heart, FileText, FileCheck, Pill, ChevronDown } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  'Stethoscope': Stethoscope,
  'Heart': Heart,
  'FileText': FileText,
  'FileCheck': FileCheck,
  'Pill': Pill
};

const ServiceAccordionItem = ({ service, isOpen, onToggle }) => {
  const IconComponent = iconMap[service.icon];
  
  return (
    <div className="service-accordion-item">
      <button 
        className="service-accordion-trigger"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-4">
          <div className="service-icon">
            <IconComponent size={24} />
          </div>
          <span className="heading-3">{service.category}</span>
        </div>
        <ChevronDown 
          size={20} 
          style={{ 
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease'
          }} 
        />
      </button>
      
      {isOpen && (
        <div className="service-accordion-content">
          <ul className="service-list">
            {service.items.map((item, index) => (
              <li key={index} className="service-list-item">
                <span className="service-bullet">•</span>
                <span className="body-medium">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const ServicesSection = () => {
  const [openItem, setOpenItem] = useState(null);

  const handleToggle = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <section id="services" className="section-padding">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Services Offered</h2>
          <p className="body-large max-w-3xl mx-auto">
            A wide range of medical services, custom-made to individual needs.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {services.map((service) => (
            <ServiceAccordionItem
              key={service.id}
              service={service}
              isOpen={openItem === service.id}
              onToggle={() => handleToggle(service.id)}
            />
          ))}
        </div>

        <div className="mt-12 glass-card p-6 max-w-4xl mx-auto">
          <h3 className="heading-3 mb-4 text-center">Coverage Areas</h3>
          <p className="body-medium text-center mb-4">
            Offering services in the following areas:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {['Durban North', 'Westville', 'Pinetown', 'New Germany', 'Kloof', 'Hillcrest', 'Overport', 
              'Sherwood', 'Musgrave', 'Reservoir Hills', 'North Beach', 'Chatsworth', 'Phoenix', 'Queensburgh', 'Umbilo'].map((area) => (
              <span key={area} className="area-badge">
                {area}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
